import Icon from '@vfz/ui/dist/components/icon/icon';
import React from 'react';

import * as S from './errormessage.styles';

interface ErrorMessageProps {
  message?: string;
  children?: React.ReactNode;
  className?: string;
  title?: string;
}

export const ErrorMessage = ({ message, children, className, ...rest }: ErrorMessageProps) => (
  <S.ErrorMessage data-testid="error-message" className={className} {...rest}>
    <Icon name="alertTriangle" variant="solid" /> {message || children}
  </S.ErrorMessage>
);
